"use client"

import type React from "react"

import { useState, useEffect } from "react"
import styles from "./RotatingCarousel.module.scss";
import { GreenBulb, SunBigIcon, ThunderIcon } from "../../../assets/icons"

interface CarouselItem {
  id: number
  component: React.ComponentType
  position: "due-right" | "rotating-in" | "rotating-out" | "hidden"
  rotationDegree: number
}

export default function RotatingCarousel() {
  const [items, setItems] = useState<CarouselItem[]>([
    { id: 1, component: ThunderIcon, position: "due-right", rotationDegree: 0 },
    { id: 2, component: SunBigIcon, position: "hidden", rotationDegree: 120 },
    { id: 3, component: GreenBulb, position: "hidden", rotationDegree: 240 },
  ])

  useEffect(() => {
    const rotateItems = () => {
      setItems((prevItems) => {
        return prevItems.map((item) => ({
          ...item,
          rotationDegree: (item.rotationDegree + 120) % 360,
          position:
            item.rotationDegree === 240
              ? "rotating-in"
              : item.rotationDegree === 0
                ? "rotating-out"
                : item.rotationDegree === 120
                  ? "hidden"
                  : item.position,
        }))
      })

      // After rotation animation completes, update positions
      setTimeout(() => {
        setItems((prevItems) => {
          return prevItems.map((item) => ({
            ...item,
            position: item.rotationDegree === 0 ? "due-right" : "hidden",
          }))
        })
      }, 800) // Match the CSS transition duration
    }

    // Start the rotation cycle
    const interval = setInterval(rotateItems, 2500) // 2.5s total cycle (800ms animation + 1.7s pause)

    return () => clearInterval(interval)
  }, [])

  return (
    <div className={styles.carousel}>
      <div className={styles.container}>
        <div className={styles.orbit}>
          {items.map((item) => {
            const IconComponent = item.component
            return (
              <div
                key={item.id}
                className={`${styles.item} ${styles[item.position]}`}
                style={
                  {
                    "--rotation": `${item.rotationDegree}deg`,
                  } as React.CSSProperties
                }
              >
                <div className={styles.itemContent}>
                  <IconComponent />
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

